import { useState } from "react";
import { Button, Card, ListGroup } from "react-bootstrap";
import { MdOutlineMarkEmailRead, MdOutlinePassword } from "react-icons/md";
import { TbAuth2Fa } from "react-icons/tb";
import SplitPane from "react-split-pane";
import UpdateProfileName from "./UpdateProfileName";
import UpdatePassword from "./UpdatePassword";
import ChangeEmail from "./ChangeEmail";
import ProfileDetails from "./ProfileDetails";

const ManageAccount = ({ getCurrectLoginUser, currentUserData }) => {
  const [activeItem, setActiveItem] = useState(null);

  function getTwoInitials(name) {
    if (!name) return "";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }
    const first = parts[0][0];
    const last = parts[parts.length - 1][0];
    return (first + last).toUpperCase();
  }

  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"25%"}
        className="position-relative"
        style={{ height: "100vh" }}
      >
        <div>
          <div className="pb-1 pt-3 px-3">
            <h5 className="fw-bold mb-1">Manage Account</h5>
          </div>
          <div
            className="p-3 overflow-auto"
            style={{ height: "calc(100vh - 106px)" }}
          >
            <Card className="border rounded-2 mb-3">
              <Card.Body className="text-center">
                <div className="hstack justify-content-center mb-2">
                  <h6 className="bg-primary-subtle p-3 rounded-1 fw-bold m-0">
                    {getTwoInitials(currentUserData?.name)}
                  </h6>
                </div>
                <h6>{currentUserData?.name}</h6>
                <Button
                  variant="outline-primary"
                  style={{ fontSize: 13 }}
                  title="Edit Details"
                  className="rounded-1 py-1 px-3 mt-2"
                  active={activeItem === "editDetails"}
                  onClick={() => setActiveItem("editDetails")}
                >
                  Edit Details
                </Button>
              </Card.Body>
            </Card>
            <ListGroup>
              <ListGroup.Item
                action
                style={{ fontSize: 13 }}
                className="hstack gap-2"
                title="Change Email"
                active={activeItem === "changeEmail"}
                onClick={() => setActiveItem("changeEmail")}
              >
                <MdOutlineMarkEmailRead /> Change Email
              </ListGroup.Item>
              <ListGroup.Item
                action
                style={{ fontSize: 13 }}
                className="hstack gap-2"
                title="Change Password"
                active={activeItem === "changePassword"}
                onClick={() => setActiveItem("changePassword")}
              >
                <MdOutlinePassword /> Change Password
              </ListGroup.Item>
              <ListGroup.Item
                action
                style={{ fontSize: 13 }}
                className="hstack gap-2"
                title="Manage Two-Factor Authentication"
                active={activeItem === "2FA"}
                onClick={() => setActiveItem("2FA")}
                disabled
              >
                <TbAuth2Fa /> Manage Two-Factor Authentication
              </ListGroup.Item>
            </ListGroup>
          </div>
        </div>
        <div>
          {activeItem === "changeEmail" ? (
            <ChangeEmail setActiveItem={setActiveItem} />
          ) : activeItem === "changePassword" ? (
            <UpdatePassword setActiveItem={setActiveItem} />
          ) : activeItem === "editDetails" ? (
            <UpdateProfileName
              setActiveItem={setActiveItem}
              getCurrectLoginUser={getCurrectLoginUser}
              currentUserData={currentUserData}
            />
          ) : (
            <div
              className="overflow-auto"
              style={{ height: "calc(100vh - 58px)" }}
            >
              <ProfileDetails
                setActiveItem={setActiveItem}
                currentUserData={currentUserData}
              />
            </div>
          )}
        </div>
      </SplitPane>
    </>
  );
};

export default ManageAccount;
